/**This component section is displayed on main page in Organisation as well as Personal Fundraising */
import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/pages/home/services/home.service';
import { StartFundraiserButtonComponent } from '../../../../../../shared/components/start-fundraiser-button/start-fundraiser-button.component';
import { NgClass, DecimalPipe } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';
@Component({
    selector: 'app-sub-footer-start-afundraiser',
    templateUrl: './sub-footer-start-afundraiser.component.html',
    styleUrls: ['./sub-footer-start-afundraiser.component.scss'],
    standalone: true,
    imports: [FlexModule, ExtendedModule, NgClass, StartFundraiserButtonComponent, DecimalPipe]
})
/** *Sub Footer Start A Fundraiser Component */
export class SubFooterStartAFundraiserComponent implements OnInit {
	activeDonors: number = 0;
	totalFundriasers: number = 0;
	constructor(public _homeService: HomeService) {}

	ngOnInit(): void {
		/** * Get Facts */
		this._homeService.getFacts().subscribe((response: any) => {
			this.activeDonors = response?.data?.active_donors;
			this.totalFundriasers = response?.data?.total_fundriasers;
		});
	}
}
